import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {SessionDataProvider} from "./components/auth/SessionDataProvider";
import { createTheme, ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import {BrowserRouter} from "react-router-dom";

const darkTheme = createTheme({
    palette: {
        mode: 'dark',
        primary: {
            main: '#7958d3', // Customize primary color
        },
        secondary: {
            main: '#222c2c', // Customize secondary color
        },
        background: {
            default: '#121212', // Customize background color
            paper: '#1d1d1d',
        },
        success: {
            main: '#008c05', // Customize success color
        },
        info: {
            main: '#0e76ed', // Customize info color
        }
    },
    components: {
        MuiButton: {
            variants: [
                {
                    props: { variant: 'blob' },
                    style: {
                        position: 'relative',
                        color: '#fff',
                        backgroundColor: '#ff0081',
                        borderRadius: '8px',
                        overflow: 'hidden',
                        zIndex: 1,
                        textTransform: 'none',
                        padding: '1rem 2rem',
                        fontSize: '1.2rem',
                        transition: 'background-color 0.3s ease',
                        filter: 'url("#goo")',
                        '&:hover': {
                            backgroundColor: '#ff4fa3',
                        },
                    },
                },
            ],
        },
    },
});

const randomImageNumber = Math.floor(Math.random() * 2) + 1;
const randomBackgroundImage = `/images/wallpapers/${randomImageNumber}.jpg`;

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
        <SessionDataProvider>
          <ThemeProvider theme={darkTheme}>
              <BrowserRouter>
                  <CssBaseline />
                      <App />
              </BrowserRouter>
          </ThemeProvider>
        </SessionDataProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
